import { useImperativeHandle } from "react";

import type { FC, Ref } from "react";

export interface SimpleSavable {
  save: () => void;
  reset: () => void;
  dirty: boolean;
}

/**
 * Generates a `Ref` to an imperative `save()`.
 */
export const SimpleSaver: FC<{
  save: () => void;
  dirty: boolean;
  reset: () => void;
  ref: Ref<SimpleSavable>;
}> = ({ save, dirty, reset, ref }) => {
  useImperativeHandle(ref, () => ({ save, dirty, reset }));
  return null;
};
